export default __webpack_public_path__ + "static/media/business.48f794f9.svg";